<template>
  <v-card class="dt-modal">
    <!-- <div class="dt-modal--header">{{ $t('email') }}</div> -->
    <div class="dt-modal--body">
      <div class="form-group">
        <div
          class="dt-input-box--container"
          style="border-radius: 5px;border:1px solid var(--sprt-5); padding:8px;"
        >
          <label class="input-box box">
            {{$t('import_file')}}
            <input
              type="file"
              id="file"
              ref="file"
              v-on:change="handleFileUpload()"
            />
          </label>
        </div>
      </div>
      <v-layout class="dt-modal--options" row wrap>
        <v-flex md6 justify-center style="display: flex; flex-direction: column">
          <div>{{importCSVContactsDoneMessage}}</div>
        </v-flex>
        <v-flex md6>
          <v-layout row wrap justify-end>
            <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
            <button
              class="dt-button v1 s7"
              :disabled="!isValidCSVFile || !fileSelected"
              @click.stop="submitFile"
              :class="{
                  'disabled': !isValidCSVFile
                }"
            >{{$t('upload_csv_contacts')}}</button>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
import { ContactIMEXService } from "../../services/contact_import_export.service";

export default {
  components: {},
  props: [],
  data: function() {
    return {
      file: "",
      importCSVContactsDoneMessage: "",
    };
  },
  watch: {},
  computed: {
    isValidCSVFile: function() {
      return this.file && (this.file.name.split(".").pop() == "csv"||this.file.name.split(".").pop() == "xlsx");
    },
    fileSelected: function() {
      return this.$refs['file'] && this.$refs['file'].value && this.$refs['file'].value.length > 0;
    }
  },
  methods: {
    onCancel: function() {
      this.$emit("cancelled");
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },

    submitFile() {
      let formData = new FormData();
      formData.append("file_name", this.file);
      formData.append("section", "import_export");
      formData.append("action", 'upload_xls_xlsx_contacts');
      ContactIMEXService.importContactCSV(formData).then(res => {
        this.$emit("done", res.data);        
        // console.log(this.$refs['file']);
        // console.log(res.data);
        if (this.$refs['file'] && this.$refs['file'].value) {
          this.reset();
        }
        if ( res.data.hasOwnProperty('total_imported') ) {
            this.importCSVContactsDoneMessage="Status: Total "+res.data.total_imported+" Contacts are imported.";
        }

        // this.importCSVContactsDoneMessage = doneMessage;

        // this.onCancel();
      }).catch(e => {
        this.$refs['file']
      });
    },

    reset() {
      this.$refs['file'].value = "";
      this.file = "";
      this.importCSVContactsDoneMessage = "";
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
